// import colors from '../../../public/colors'


export default theme => {
    // const { mode } = theme.palette
    return {
        customLoader: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
        },
        img: {
            height: '125px',
            width: '125px'
        }
    }
}
